import { render, staticRenderFns } from "./AppletContain.vue?vue&type=template&id=8e28ac5a&scoped=true&"
import script from "./AppletContain.vue?vue&type=script&lang=js&"
export * from "./AppletContain.vue?vue&type=script&lang=js&"
import style0 from "./AppletContain.vue?vue&type=style&index=0&id=8e28ac5a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e28ac5a",
  null
  
)

export default component.exports